import { HydratorConfig } from "./types/index.js";

export function setUrl(rowKey?: string) {
  const url = new URL(window.location.href);

  if (rowKey) {
    url.searchParams.set("rowKey", rowKey);
  } else {
    url.searchParams.delete("rowKey");
  }

  window.history.pushState({ path: url.toString() }, "", url.toString());
}

export function serializeForm(form: HTMLFormElement) {
  return new URLSearchParams(
    Array.from(new FormData(form).entries()).flatMap(([key, value]) =>
      typeof value === "string" ? [[key, value]] : [],
    ),
  ).toString();
}

export function executeScripts(scripts: HTMLScriptElement[]) {
  for (const originalScript of scripts) {
    const script = document.createElement("script");

    for (const attribute of originalScript.attributes) {
      script.setAttribute(attribute.name, attribute.value);
    }

    script.textContent = originalScript.textContent;
    document.body.appendChild(script);
    document.body.removeChild(script);
  }
}

export function createHydratorConfig<TResponse extends Record<string, unknown>>(
  options: Omit<HydratorConfig<TResponse>, "getForm" | "replaceForm">,
): HydratorConfig<TResponse> {
  function getForm(): HTMLFormElement | null {
    return document.getElementById(options.formId) as HTMLFormElement | null;
  }

  function replaceForm(markup: string) {
    const currentForm = getForm();

    if (!currentForm) {
      return;
    }

    const template = document.createElement("template");
    template.innerHTML = markup.trim();

    const nextForm = template.content.querySelector(
      `#${options.formId}`,
    ) as HTMLFormElement | null;

    if (!nextForm) {
      return;
    }

    const scripts = Array.from(
      template.content.querySelectorAll("script"),
    ) as HTMLScriptElement[];

    for (const script of scripts) {
      script.remove();
    }

    kendo.destroy(currentForm);
    currentForm.replaceWith(nextForm);

    if (scripts.length > 0) {
      executeScripts(scripts);
    } else {
      kendo.init(nextForm);
    }
  }

  return {
    ...options,
    getForm,
    replaceForm,
  } as HydratorConfig<TResponse>;
}
